import React from "react";
import DataTable from "react-data-table-component";
import uuid from "react-uuid";
import "./ClassTable.css";

// updated with accessability fixes by JA 05-04-23

let windowObjectReference = null; // global variable

const handleAnchorClick = (e) => {
  e.preventDefault();
  if (windowObjectReference === null || windowObjectReference.closed) {
    windowObjectReference = window.open(
      e.currentTarget.href,
      "OpenBookStoreWindow",
      "popup,width=600,height=600,top=((screen.height - 600)/2),left=((screen.width - 600)/2)"
    );
  } else {
    windowObjectReference.focus();
  }
};

const ExpandedComponent = (section) => {
  return (
    //conditional rendering to avoid displaying if the atribute is missing
    <div key={uuid()} className="class-info-exp">
      <div className="class-info-main">
        {section.data.class_title && (
          <p className="class_title">
            <span>Class Title: </span>
            {section.data.class_title}
            console.log({section.data.class_title})
          </p>
        )}

        {section.data.lccm === "t" ? (
          <p className="class_book low-cost-book-icon">
            <a
              title="Textbook / Other Materials"
              className="bookpopup"
              onClick={handleAnchorClick}
              href={`//www.bkstr.com/webapp/wcs/stores/servlet/booklookServlet?bookstore_id-1=037&term_id-1=${section.data.term_code}&div-1=&dept-1=${section.data.subject_code}&course-1=${section.data.catalog_number}&section-1=${section.data.class_section}`}
            >
              <img
                src={`//www.csus.edu/dev/class_schedule/low-cost-book-icon.png`}
                alt={`book for ${section.data.class_title} Section ${section.data.class_section}`}
                width="16"
                height="16"
              />{" "}
              <span>Order Low-Cost Textbook</span>
            </a>
          </p>
        ) : section.data.zccm === "t" ? (
          <p className="class_book zero-cost-book-icon">
            <img
              src={`//www.csus.edu/dev/class_schedule/zero-cost-book-icon.png`}
              alt={`book for ${section.data.class_title} Section ${section.data.class_section}`}
              width="16"
              height="16"
            />
            <span>Zero-Cost Course Materials</span>
          </p>
        ) : (
          <p className="class_book book-icon">
            <a
              title="Textbook / Other Materials"
              className="bookpopup"
              onClick={handleAnchorClick}
              href={`//www.bkstr.com/webapp/wcs/stores/servlet/booklookServlet?bookstore_id-1=037&term_id-1=${section.data.term_code}&div-1=&dept-1=${section.data.subject_code}&course-1=${section.data.catalog_number}&section-1=${section.data.class_section}`}
            >
              <img
                src={`//www.csus.edu/dev/class_schedule/book-icon.png`}
                alt={`book for ${section.data.class_title} Section ${section.data.class_section}`}
                width="16"
                height="16"
              />
              <span>Order Textbook</span>
            </a>
          </p>
        )}

        {section.data.instructor && (
          <p className="class_instructor">
            <span>Instructor: </span>
            {section.data.instructor}
          </p>
        )}
        {section.data.component && (
          <p className="class_component">
            <span>Component: </span> {section.data.component}
          </p>
        )}
        {section.data.building && (
          <p className="class_building">
            <span>Building: </span>
            {section.data.building}
          </p>
        )}
        {section.data.room && (
          <p className="class_room">
            <span>Room: </span> {section.data.room}
          </p>
        )}
        {section.data.days && (
          <p className="class_days">
            <span>Days: </span> {section.data.days}
          </p>
        )}
        {section.data.start_time && (
          <p className="class_start_time">
            <span>Start Time: </span> {section.data.start_time}
          </p>
        )}
        {section.data.end_time && (
          <p className="class_end_time">
            <span>End Time: </span>
            {section.data.end_time}
          </p>
        )}
      </div>
      <div className="class-info-data">
        {section.data.class_section && (
          <p className="class_section">
            <span>Class Section: </span> {section.data.class_section}
          </p>
        )}
        {section.data.course_id && (
          <p className="class_course_id">
            <span>Course ID: </span> {section.data.course_id}
          </p>
        )}
        {section.data.class_number && (
          <p className="class_number">
            <span>Class Number: </span> {section.data.class_number}
          </p>
        )}
        {section.data.seats_total && (
          <p className="class_seats_total">
            <span>Seats Total: </span> {section.data.seats_total}
          </p>
        )}
        {section.data.seats_available && (
          <p className="class_available">
            <span>Seats Available: </span> {section.data.seats_available}
          </p>
        )}
      </div>
      <div className="class-info-other">
        {section.data.ge_grad_req && (
          <p className="class_attributes">
            <span>Class attributes: </span> {section.data.ge_grad_req}
          </p>
        )}
        {section.data.class_meeting_start_date && (
          <p className="class_meeting_start_date">
            <span>Class Meeting Start Date: </span>{" "}
            {section.data.class_meeting_start_date}
          </p>
        )}
        {section.data.class_meeting_end_date && (
          <p className="class_meeting_end_date">
            <span>Class Meeting End Date: </span>{" "}
            {section.data.class_meeting_end_date}
          </p>
        )}
      </div>
    </div>
  );
};

export default function ClassTable({ section }) {
  const columns = [
    {
      id: `${section.subject_code}-${uuid()}`,
      name: "Class Section",
      type: "",
      sortable: "true",
      center: "true",
      compact: "true",
      selector: (row) => row.class_section,
    },
    {
      id: `${section.subject_code}-${uuid()}`,
      name: "Seats Available",
      type: "",
      sortable: "true",
      center: "true",
      compact: "true",
      selector: (row) => row.seats_available,
    },
    {
      id: `${section.subject_code}-${uuid()}`,
      name: "Days",
      hide: "sm",
      type: "",
      sortable: "true",
      center: "true",
      selector: (row) => row.days,
    },
    {
      id: `${section.subject_code}-${uuid()}`,
      name: "Instructor",
      type: "",
      sortable: "true",
      hide: "sm",
      wrap: "true",
      selector: (row) => row.instructor,
    },
    {
      id: `${section.subject_code}-${uuid()}`,
      name: "Start Time",
      type: "",
      sortable: "true",
      hide: "sm",
      center: "true",
      selector: (row) => row.start_time,
    },
    {
      id: `${section.subject_code}-${uuid()}`,
      name: "End Time",
      type: "",
      hide: "sm",
      sortable: "true",
      center: "true",
      selector: (row) => row.end_time,
    },
    {
      id: `${section.subject_code}-${uuid()}`,
      name: "Building",
      type: "",
      sortable: "true",
      hide: "sm",
      center: "true",
      selector: (row) => row.building,
    },
  ];

  const rows = section.sections.map((section) => ({
    id: uuid(),
    ...section,
  }));

  return (
    <>
      <div className="table" key={uuid()}>
        <h2 id={section.subject_code + "-" + section.catalog_number}>
          {section.subject_code +
            " " +
            section.catalog_number +
            " - " +
            section.class_title +
            " - " +
            section.units +
            " Units"}
        </h2>
        <p>{section.class_ldesc}</p>
        <p>
          *Click on the first column in each table row to see class details.
        </p>
        <DataTable
          keyField="id"
          columns={columns}
          data={rows}
          expandableRows
          fixedHeader
          compact
          selectableRowsHighlight
          expandableRowsComponent={(e) => ExpandedComponent(e, rows)}
        />
      </div>
    </>
  );
}
